import {
  Md360,
  MdAdd,
  MdAddCircleOutline,
  MdAutoAwesome,
  MdCalendarToday,
  MdCancel,
  MdCheck,
  MdCheckBox,
  MdCheckCircle,
  MdCheckCircleOutline,
  MdChecklist,
  MdChevronLeft,
  MdChevronRight,
  MdClose,
  MdCloseFullscreen,
  MdContentCopy,
  MdFileUpload,
  MdFlag,
  MdFormatListBulleted,
  MdFunctions,
  MdInfo,
  MdInfoOutline,
  MdKeyboardArrowDown,
  MdKeyboardArrowUp,
  MdLock,
  MdLockOpen,
  MdNotes,
  MdOpenInFull,
  MdOpenInNew,
  MdOutlineAddAlert,
  MdOutlineAlarm,
  MdOutlineComment,
  MdOutlineDelete,
  MdOutlineDownload,
  MdOutlineDriveFileMove,
  MdOutlineEdit,
  MdOutlineImage,
  MdOutlineLink,
  MdOutlineLooksOne,
  MdOutlineMoreVert,
  MdOutlineNotifications,
  MdOutlinePayments,
  MdOutlinePerson,
  MdOutlineSchedule,
  MdOutlineSquare,
  MdOutlineTripOrigin,
  MdOutlineVideocam,
  MdOutlineViewTimeline,
  MdOutlineVisibility,
  MdOutlineVisibilityOff,
  MdOutlinedFlag,
  MdPercent,
  MdTextFields,
  MdWarning,
} from 'react-icons/md';

import materialSymbol from './materialSymbol.jsx';

const FORMAT_PARAGRAPH_PATH =
  'M400-160q-17 0-28.5-11.5T360-200v-200q-83 0-141.5-58.5T160-600q0-83 58.5-141.5T360-800h320q17 0 28.5 11.5T720-760q0 17-11.5 28.5T680-720h-40v520q0 17-11.5 28.5T600-160q-17 0-28.5-11.5T560-200v-520H440v520q0 17-11.5 28.5T400-160Z';

const PAUSE_PATH =
  'M520-200v-560h240v560H520Zm-320 0v-560h240v560H200Zm400-80h80v-400h-80v400Zm-320 0h80v-400h-80v400Zm0-400v400-400Zm320 0v400-400Z';
const PLAY_ARROW_PATH = 'M320-200v-560l440 280-440 280Zm80-280Zm0 134 210-134-210-134v268Z';
const RECORD_PATH =
  'M480-480ZM282-282q-82-82-82-198t82-198q82-82 198-82t198 82q82 82 82 198t-82 198q-82 82-198 82t-198-82Zm339.5-56.5Q680-397 680-480t-58.5-141.5Q563-680 480-680t-141.5 58.5Q280-563 280-480t58.5 141.5Q397-280 480-280t141.5-58.5Z';
const STOP_PATH = 'M320-640v320-320Zm-80 400v-480h480v480H240Zm80-80h320v-320H320v320Z';

export default {
  add: MdAdd,
  addAlert: MdOutlineAddAlert,
  addCircleOutline: MdAddCircleOutline,
  alarm: MdOutlineAlarm,
  autoAwesome: MdAutoAwesome,
  calendarToday: MdCalendarToday,
  cancel: MdCancel,
  check: MdCheck,
  checkBox: MdCheckBox,
  checkCircle: MdCheckCircle,
  checkCircleOutline: MdCheckCircleOutline,
  checklist: MdChecklist,
  chevronLeft: MdChevronLeft,
  chevronRight: MdChevronRight,
  close: MdClose,
  closeFullscreen: MdCloseFullscreen,
  comment: MdOutlineComment,
  contentCopy: MdContentCopy,
  delete: MdOutlineDelete,
  download: MdOutlineDownload,
  driveFileMove: MdOutlineDriveFileMove,
  edit: MdOutlineEdit,
  fileUpload: MdFileUpload,
  flag: MdFlag,
  flagOutline: MdOutlinedFlag,
  formatListBulleted: MdFormatListBulleted,
  formatParagraph: materialSymbol('format_paragraph', FORMAT_PARAGRAPH_PATH),
  functions: MdFunctions,
  image: MdOutlineImage,
  info: MdInfo,
  infoOutline: MdInfoOutline,
  keyboardArrowDown: MdKeyboardArrowDown,
  keyboardArrowUp: MdKeyboardArrowUp,
  link: MdOutlineLink,
  lock: MdLock,
  lockOpen: MdLockOpen,
  looksOne: MdOutlineLooksOne,
  moreVert: MdOutlineMoreVert,
  notes: MdNotes,
  notifications: MdOutlineNotifications,
  openInFull: MdOpenInFull,
  openInNew: MdOpenInNew,
  pause: materialSymbol('pause', PAUSE_PATH),
  payments: MdOutlinePayments,
  percent: MdPercent,
  person: MdOutlinePerson,
  playArrow: materialSymbol('play_arrow', PLAY_ARROW_PATH),
  record: materialSymbol('fiber_manual_record', RECORD_PATH),
  schedule: MdOutlineSchedule,
  square: MdOutlineSquare,
  stop: materialSymbol('stop', STOP_PATH),
  textFields: MdTextFields,
  threeSixty: Md360,
  tripOrigin: MdOutlineTripOrigin,
  videocam: MdOutlineVideocam,
  viewTimeline: MdOutlineViewTimeline,
  visibility: MdOutlineVisibility,
  visibilityOff: MdOutlineVisibilityOff,
  warning: MdWarning,
};
